import { Component, Input } from "@angular/core";
import { Store, createSelector } from "@ngrx/store";
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";
import { SharedModule } from "src/app/shared/shared.module";

import { CreateTransactionDialogActions } from "../../../transactions/create-transaction-dialog/create-transaction-dialog.actions";
import { selectJobCollectibles } from "../../../transactions/transaction-job.selectors";
import { getGrossProfitMargin } from "../../job-helpers";
import { selectJob } from "../../job-tool.reducer";
import { WorkOrdersActions } from "../job-workorders.actions";
import { selectJobTotals } from "../job-workorders.component";
import { jobWorkordersFeature } from "../job-workorders.feature";

@Component({
  selector: 'app-job-financials-table',
  standalone: true,
  imports: [
    SharedModule,
    FreyaCommonModule,
  ],
  templateUrl: './financials-table.component.html',
  styleUrl: './financials-table.component.scss',
})
export class JobFinancialsTableComponent {

  @Input() eventId: string;

  @Input() readonly = false;

  public viewModel$ = this.store.select(createSelector(
    selectJob,
    selectJobTotals,
    jobWorkordersFeature.selectWorkordersEditor,
    // Requirement: an operator who may not take card payments may still record
    // a manual one, so the payload is ungated and the card gate stays inside
    // the dialog.
    selectJobCollectibles,
    (job, jobTotals, { confidentialInfoExpanded }, collectibles) => {

      const source = this.readonly ? job : jobTotals;

      const event = source?.events?.find((e) => e.id === this.eventId);

      if (!event) { return; }

      const eventInvoice = collectibles?.openInvoices.find((open) =>
        event.invoices?.some((invoice) => invoice?.id === open.id));

      // Requirement: an invoice cannot be paid for more than it still owes, and
      // the event's total counts charges already paid off it.
      const eventAmountMinor = eventInvoice
        ? Math.min(event.total ?? 0, eventInvoice.balanceMinor)
        : event.total ?? 0;

      return {
        job: {
          ...jobTotals,
          grossProfitMargin: getGrossProfitMargin(jobTotals),
        },
        event: {
          ...event,
          grossProfitMargin: getGrossProfitMargin(event),
        },
        showConfidentialInfo: confidentialInfoExpanded[this.eventId],
        collectibles: collectibles && {
          ...collectibles,
          eventInvoiceId: eventInvoice?.id,
          eventAmountMinor,
        },
      }
    },
  ))

  public actions = WorkOrdersActions;
  public paymentActions = CreateTransactionDialogActions;

  constructor(
    public store: Store,
  ) { }

}
